import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { getLang } from 'modules/cookies';
import { loadResources } from './localization-actions';
import { LOCALIZATION_EVENTS, LOCALIZATION_STORE_NAME } from './localization-constants';
import { LocalizationStore } from './localization-types';

const INITIAL_STATE: LocalizationStore = {
  initialI18nStore: { ru: { translation: {} } },
  initialLanguage: '',
  error: null,
  loading: false,
} as const;

export const localization = (parentStore: Store) => {
  const store = createSubstore(parentStore, LOCALIZATION_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(LOCALIZATION_EVENTS.init, async (_, { ns }) => {
    const { loading } = store.get();
    const { cookies } = parentStore.get();

    if (loading) {
      return Promise.resolve();
    }

    store.dispatch(LOCALIZATION_EVENTS.load);
    const lang = getLang(cookies);

    try {
      const localizationData = await loadResources(lang, ns);
      store.dispatch(LOCALIZATION_EVENTS.set, localizationData);
    } catch (e) {
      store.dispatch(LOCALIZATION_EVENTS.failure, `Не удалось загрузить перевод для лендинга ${ns}`);
    }

    return Promise.resolve();
  });
  store.on(LOCALIZATION_EVENTS.load, state => ({ ...state, loading: true }));
  store.on(LOCALIZATION_EVENTS.failure, (state, error) => ({ ...state, error, loading: false }));
  store.on(LOCALIZATION_EVENTS.set, (_, res) => ({ ...res, error: null, loading: false }));
};
